<template>
  <main>
    <div class="bg-gray-200 py-2">
      <div class="breadcrumbs container mx-auto">
        <nuxt-link :to="localePath('index')" class="breadcrumb  px-2">
          {{ $t('home') }}</nuxt-link
        >
        <nuxt-link :to="localePath('about')" class="breadcrumb  px-2">
          {{ $t('about_us') }}</nuxt-link
        >
        <nuxt-link :to="localePath('about-history')" class="breadcrumb  px-2">
          {{ $t('history') }}</nuxt-link
        >
      </div>
    </div>
    <div
      class="submenu px-4 py-8 container mx-auto flex flex-col md:flex-row justify-center"
    >
      <nuxt-link
        :to="localePath('about-history')"
        class="items-center flex flex-col md:w-1/4"
      >
        <img class="self-center submenu-icon" src="/img/icons/history.png" />
        <p class="text-black text-center mt-0 mb-4">{{ $t('history') }}</p>
      </nuxt-link>
      <nuxt-link
        :to="localePath('about-numbers')"
        class="items-center flex flex-col md:w-1/4"
      >
        <img
          class="self-center submenu-icon"
          src="/img/icons/numbers_and_facts.png"
        />
        <p class="text-black text-center mt-0 mb-4">
          {{ $t('numbers_and_facts') }}
        </p>
      </nuxt-link>
      <nuxt-link
        :to="localePath('about-certificates')"
        class="items-center flex flex-col md:w-1/4"
      >
        <img
          class="self-center submenu-icon"
          src="/img/icons/certificates.png"
        />
        <p class="text-black text-center mt-0 mb-4">{{ $t('certificates') }}</p>
      </nuxt-link>
    </div>
    <div class="header text-center py-32">
      <h1 class="text-3xl text-white font-bold">{{ $t('our_history') }}</h1>
    </div>
    <section class="about px-4 container mx-auto text-justify">
      <div class="about-content bg-white px-8 py-8 md:px-20 md:py-20">
        <h3 class="text-2xl font-semibold mb-4">{{ $t('overview') }}</h3>
        <div class="flex">
          <p class="text-grey-600">{{ $t('our_history_full') }}</p>
        </div>
      </div>

      <div class="text-center my-6 pb-4">
        <h4 class="font-bold text-2xl">{{ $t('anything_you_need_help') }}</h4>
        <div class="flex flex-wrap justify-center">
          <nuxt-link
            :to="localePath('solutions')"
            class="button w-56 bg-red-600 hover:bg-red-700 px-12 uppercase hover:text-white mt-6 sm:mr-3 text-white px-5 py-3"
            >{{ $t('OUR_SOLUTIONS') }}</nuxt-link
          >
          <nuxt-link
            :to="localePath('contact')"
            class="button w-56 bg-transparent text-black uppercase border-2 border-black px-5 py-3 mt-6 hover:bg-black hover:text-white"
            >{{ $t('contact') }}</nuxt-link
          >
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {}
</script>

<style scoped>
.submenu-icon {
  @apply mb-3;
}
.header {
  background: linear-gradient(to right, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0)),
    url('/img/about_header_background.jpg');
  background-position: center;
  background-size: cover;
  position: relative;
}
.header:after {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  transform: translateY(100%);
  left: 0;
  bottom: 0;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.05), transparent);
  z-index: -1;
}
.about-content {
  transform: translateY(-75px);
  z-index: 999;
}
</style>
